export interface PillProps {
  text: string
  colorClass?: string
}

export function Pill({ text, colorClass }: PillProps) {
  return <div className={`pill ${colorClass}`}>{text}</div>
}
